import {
  filtersFindMoreClickParams,
  navigationButtonClickParams,
  newSearchClickParams,
} from '@wix/bi-logger-media-data/v2/types';
import { filtersFindMoreClick, navigationButtonClick, newSearchClick } from '@wix/bi-logger-media-data/v2';

import { isNil } from 'ramda';
import { useMemo } from 'react';
import { bi } from '../../../services/loggers/bi';

export enum NavigationButtonNames {
  Left = 'nav_left',
  Right = 'nav_right',
}

export enum FiltersFindMoreClickOrigins {
  FindMore = 'filter_find_more',
  Wide = 'filter_wide',
}

export enum NewSearchButtonNames {
  NewSearch = 'new_search',
  SearchAgain = 'search_again',
}

export function getNavigationButtonClickTarget(sourceName, subCategoryId) {
  const sourceNameLowerCase = sourceName.toLowerCase();

  if (!isNil(subCategoryId)) {
    return `${subCategoryId}_${sourceNameLowerCase}`;
  }

  return sourceNameLowerCase;
}

export const useTrackSearch = () =>
  useMemo(
    () => ({
      trackAddMediaButtonClickSideBar: (params: navigationButtonClickParams) =>
        bi.logger().report(navigationButtonClick(params)),
      trackFiltersFindMoreClick: (params: filtersFindMoreClickParams) =>
        bi.logger().report(filtersFindMoreClick(params)),
      trackNewSearchClick: (params: newSearchClickParams) => bi.logger().report(newSearchClick(params)),
    }),
    [],
  );
